<template>
  <div class="flex w-full items-baseline justify-between">
    <!--
      The one subheadline style the forms use (TM-9602): 14px, extrabold, gray-900 —
      the same line that separates Patientendaten from Kontakt in the profile.
    -->
    <h3 class="text-tm-gray-900 text-sm font-extrabold">{{ props.heading }}</h3>
    <slot />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  heading: string;
}>();
</script>
